const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const SocialIcon = require('module/icons/social_icon')

function showMessageModal() {
    require.ensure([], () => {
        const radio = require('lib/radio')
        const user = radio.profile.request('user')
        const Message = require('module/message/message')

        return new Message({
            user,
            modal: true,
        })
    }, 'message-modal')
}

function ContactMeButton({ user }) {
    const className = classNames('contact-me', {
        editing: user.contact_me.editing,
    })

    return (
        <li
            className={className}
            title="Send me a message"
            onClick={showMessageModal}
            >
            <SocialIcon glyph="email" />
        </li>
    )
}

ContactMeButton.propTypes = {
    user: PropTypes.shape({
        contact_me: PropTypes.object,
    }).isRequired,
}

module.exports = ContactMeButton
